import { mapGetters } from 'vuex'
import errors from '@/api/errors'
export default {
  computed: {
    ...mapGetters({
      isGlobalError: 'commons/isGlobalError',
      globalErrorMessage: 'commons/globalErrorMessage',
      isAuthenticationError: 'commons/isAuthenticationError',
      authenticationErrorMessage: 'commons/authenticationErrorMessage',
      validateAccessToken: 'commons/validateAccessToken'
    })
  },
  methods: {
    onAuthenticationError () {
      // 確認ダイアログを表示してログイン画面に遷移する
      if (confirm(this.authenticationErrorMessage)) {
        this.redirectAuth()
      }
    },
    onAuthenticationConfirm () {
      const error = new errors.AuthenticationError()
      this.$store.dispatch('commons/setGlobalError', error, { root: true }).then(() => {
        // 確認ダイアログを表示してログイン画面に遷移する
        if (confirm(this.authenticationErrorMessage)) {
          this.redirectAuth()
        }
      })
    },
    redirectAuth () {
      // エンコードされているので、ここでは encodeURI はやらない
      // const encoded = encodeURI(location.pathname + location.search)
      const encoded = location.pathname + location.search
      location.href = `${process.env.AUTH_URL}?authLevel=1&destUrl=${encoded}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/errors.js